module.exports = __webpack_public_path__ + "img/s5-300x75.7ed8e551.jpg";